<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="90%"
    append-to-body
    top="5vh"
    center
  >
    <div class="content">
      <!-- <p style="text-align: center">
        <img
          src="../../assets/imgs/baqiaozheng.png"
          style="width: 100px; height: 100px"
          alt=""
        />
        哈哈哈
      </p> -->
      <div class="text-center title-box text-bold" style="font-size: 30px">
        {{ detail.title }}
      </div>
      <div class="flex justify-center items-center">
        <div v-html="detail.content"></div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "NoticeDialog",
  data() {
    return {};
  },
  props: {
    show: Boolean,
    detail: Object,
  },
  methods: {},
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  font-size: 20px;
  color: #333;
}
.title-box {
  //   background: linear-gradient(to left, #0d0c2f 0%, #103253 50%, #0d0c2f 100%);
  padding: 50px;
}
// ::v-deep {
//   .el-dialog {
//     // 取消阴影和背景色
//     background: rgba(0, 0, 0, 0);

//     -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//     backdrop-filter: blur(10px);
//   }
//   .el-dialog__headerbtn {
//     top: 78px;
//     right: 100px;
//     z-index: 122;
//     font-size: 30px;
//     color: #fff;
//     font-size: bold;
//   }
//   .el-table,
//   .el-table__body {
//     background: transparent !important;
//     color: #fff;
//   }
//   .el-table th {
//     background-color: transparent !important;
//   }
//   .el-table tr {
//     background-color: transparent !important;
//   }
//   .el-table__body tr.hover-row > td {
//     background-color: #a5ccf2 !important;
//   }
//   .el-table tbody tr:hover > td {
//     background-color: #17468d !important //修改成自己想要的颜色即可
// ;
//   }
// }
</style>
